"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: Covid tables
// TODO: Market share tables
function yearFact(dataset, name, altName, additionalForeignKeys) {
    let def = {
        name,
        altName,
        tableType: 'fact',
        grain: [
            dataset + '::key',
            'year::key',
        ],
        tableGrain: [
            '!' + dataset,
            'year_key',
        ],
        foreignKeys: [
            dataset + '::key'
        ]
    };
    if (additionalForeignKeys)
        def.foreignKeys.push(...additionalForeignKeys);
    return def;
}
function healthSystemFact(name, altName = undefined) {
    return yearFact('health-system', name, altName);
}
function facilityFact(name, altName = undefined) {
    return yearFact('facility', name, altName, ['facility:hospital-directory::key']);
}
const hacDomain = facilityFact('hac-domain', 'hospital-hac-domain');
const hsAllPatientsDaysTripsVisits = healthSystemFact('health-system-all-patients-days-trips-visits', 'healthsystem-ap-dtv');
const hsBedDays = healthSystemFact('health-system-bed-days', 'healthsystem-bed-days');
const hsBeds = healthSystemFact('health-system-beds', 'healthsystem-beds');
const hsCah = healthSystemFact('health-system-cah', 'healthsystem-cah');
const hsCalculatedMetrics = healthSystemFact('health-system-calculated-metrics', 'healthsystem-calc-metrics');
const hsCapitalAccounts = healthSystemFact('health-system-capital-accounts', 'healthsystem-cap-acct');
const hsCaseMixIndex = healthSystemFact('health-system-case-mix-index', 'healthsystem-case-mix-index');
const hsCost = healthSystemFact('health-system-cost', 'healthsystem-cost');
const healthSystem = {
    name: 'health-system',
    altName: 'healthsystem',
    tableType: 'dim',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: ['!health-system'],
    foreignKeys: ['zip-geo::key'],
};
const affiliatedHealthSystem = Object.assign({ ...healthSystem }, { name: 'affiliated-health-system', altName: 'affiliated-healthsystem' });
const hsDischarges = healthSystemFact('health-system-discharges', 'healthsystem-discharges');
const hsEocByDrgGroup = {
    name: 'health-system-episodes-of-care-by-drg-group',
    tableType: 'fact',
    grain: [
        'drg_group',
        'year::key',
        'health-system::key',
    ],
    claimsColumns: [
        'count_of_episodes',
    ],
    tableGrain: [
        'drg_group',
        'year_key',
        '!health-system',
    ],
    foreignKeys: [
        'health-system::key',
    ]
};
const hsFullTimeEquivalents = healthSystemFact('health-system-full-time-equivalents', 'healthsystem-full-time-eq');
const hsHacDomain = healthSystemFact('health-system-hac-domain', 'healthsystem-hac-domain');
const hsIncome = healthSystemFact('health-system-income', 'healthsystem-income');
const hsInpatientRevenue = healthSystemFact('health-system-inpatient-revenue', 'healthsystem-in-revenue');
const hsMedicareVolume = healthSystemFact('health-system-medicare-volume', 'healthsystem-medicare-volume');
const hsOutpatientImagingEfficiency = healthSystemFact('health-system-outpatient-imaging-efficiency', 'healthsystem-outpatient-img-eff');
const hsOutpatientRevenue = healthSystemFact('health-system-outpatient-revenue', 'healthsystem-out-revenue');
const hsOverhead = healthSystemFact('health-system-overhead', 'healthsystem-overhead');
const hsPaymentReduction = healthSystemFact('health-system-payment-reduction');
const hsReadmissionsReduction = healthSystemFact('health-system-readmissions-reduction', 'healthsystem-readm-reduction');
const hsRevenue = healthSystemFact('health-system-revenue', 'healthsystem-revenue');
const hsTotalRevenue = healthSystemFact('health-system-total-revenue', 'healthsystem-total-revenue');
const hsValueBasedPurchasing = healthSystemFact('health-system-value-based-purchasing', 'healthsystem-value-based-purchasing');
const hsVbpExposure = healthSystemFact('health-system-vbp-exposure', 'healthsystem-vbp-exposure');
const hsWages = healthSystemFact('health-system-wages', 'healthsystem-wages');
const hsAPMContracts = healthSystemFact('health-system-apm-contracts', 'healthsystem-apm-contracts');
const hospCaseMixIndex = facilityFact('hospital-case-mix-index');
const hospCRAllPatientsDaysTripsVisits = facilityFact('hospital-cost-report-all-patients-days-trips-visits', 'hospital-cr-ap-dtv');
const hospCRBedDays = facilityFact('hospital-cost-report-bed-days', 'hospital-cr-bed-days');
const hospCRBeds = facilityFact('hospital-cost-report-beds', 'hospital-cr-beds');
const hospCRCah = facilityFact('hospital-cost-report-cah', 'hospital-cr-cah');
const hospCRCalculatedMetrics = facilityFact('hospital-cost-report-calculated-metrics', 'hospital-cr-calc-metrics');
const hospCRCapitalAccounts = facilityFact('hospital-cost-report-capital-accounts', 'hospital-cr-cap-acct');
const hospCRCost = facilityFact('hospital-cost-report-cost', 'hospital-cr-cost');
const hospCRDischarges = facilityFact('hospital-cost-report-discharges', 'hospital-cr-discharges');
const hospCREndowmentFundAssets = facilityFact('hospital-cost-report-endowment-fund-assets', 'hospital-cr-ef-assets');
const hospCREndowmentFundLiabilities = facilityFact('hospital-cost-report-endowment-fund-liabilities', 'hospital-cr-ef-liabilities');
const hospCRFullTimeEquivalents = facilityFact('hospital-cost-report-full-time-equivalents', 'hospital-cr-full-time-eq');
const hospCRGeneralFundAssets = facilityFact('hospital-cost-report-general-fund-assets', 'hospital-cr-gf-assets');
const hospCRGeneralFundLiabilities = facilityFact('hospital-cost-report-general-fund-liabilities', 'hospital-cr-gf-liabilities');
const hospCRIncome = facilityFact('hospital-cost-report-income', 'hospital-cr-income');
const hospCRInpatientRevenue = facilityFact('hospital-cost-report-inpatient-revenue', 'hospital-cr-in-revenue');
const hospCROutpatientRevenue = facilityFact('hospital-cost-report-outpatient-revenue', 'hospital-cr-out-revenue');
const hospCROverhead = facilityFact('hospital-cost-report-overhead', 'hospital-cr-overhead');
const hospCRPlantFundAssets = facilityFact('hospital-cost-report-plant-fund-assets', 'hospital-cr-pf-assets');
const hospCRPlantFundLiabilities = facilityFact('hospital-cost-report-plant-fund-liabilities', 'hospital-cr-pf-liabilities');
const hospCRRevenue = facilityFact('hospital-cost-report-revenue', 'hospital-cr-revenue');
const hospCRSpecificPurposeFundAssets = facilityFact('hospital-cost-report-specific-purpose-fund-assets', 'hospital-cr-spf-assets');
const hospCRSpecificPurposeFundLiabilities = facilityFact('hospital-cost-report-specific-purpose-fund-liabilities', 'hospital-cr-spf-liabilities');
const hospCRTitleVDaysTripsVisits = facilityFact('hospital-cost-report-title-v-days-trips-visits', 'hospital-cr-t5-dtv');
const hospCRTitleXIXDaysTripsVisits = facilityFact('hospital-cost-report-title-xix-days-trips-visits', 'hospital-cr-t19-dtv');
const hospCRTitleXVIIIDaysTripsVisits = facilityFact('hospital-cost-report-title-xviii-days-trips-visits', 'hospital-cr-t18-dtv');
const hospCRTotalFundAssets = facilityFact('hospital-cost-report-total-fund-assets', 'hospital-cr-tf-assets');
const hospCRTotalRevenue = facilityFact('hospital-cost-report-total-revenue', 'hospital-cr-total-revenue');
const hospCRWages = facilityFact('hospital-cost-report-wages', 'hospital-cr-wages');
const hospMdcCaseMixIndex = facilityFact('hospital-mdc-case-mix-index');
const hospMedsurgCaseMixIndex = facilityFact('hospital-medsurg-case-mix-index');
const hospOwnershipEocByDrgGroup = {
    name: 'hospital-ownership-episodes-of-care-by-drg-group',
    tableType: 'fact',
    grain: [
        'hospital_ownership',
        'drg_group',
        'year::key',
    ],
    claimsColumns: [
        'count_of_episodes',
    ],
    tableGrain: [
        'hospital_ownership',
        'drg_group',
        'year_key',
    ],
    foreignKeys: [],
};
const hospTypeEocByDrgGroup = {
    name: 'hospital-type-episodes-of-care-by-drg-group',
    tableType: 'fact',
    grain: [
        'hospital_type',
        'drg_group',
        'year::key',
    ],
    claimsColumns: [
        'count_of_episodes',
    ],
    tableGrain: [
        'hospital_type',
        'drg_group',
        'year_key',
    ],
    foreignKeys: [],
};
const medicareVolume = facilityFact('medicare-volume', 'hospital-medicare-volume');
const outpatientImagingEfficiency = facilityFact('outpatient-imaging-efficiency', 'hospital-outpatient-img-eff');
const paymentReduction = facilityFact('payment-reduction', 'hospital-payment-reduction');
const readmissionsComplicationsAndDeaths = facilityFact('readmissions-complications-and-deaths', 'hospital-readm-comp-death');
const readmissionsReduction = facilityFact('readmissions-reduction', 'hospital-readm-reduction');
const structuralMeasures = facilityFact('structural-measures', 'hospital-struct-measures');
const timelyAndEffectiveCare = facilityFact('timely-and-effective-care', 'hospital-time-eff-care');
const valueBasedPurchasing = facilityFact('value-based-purchasing', 'hospital-value-based-purchasing');
const hospitalPricing = {
    name: 'hospital-pricing',
    tableType: 'fact',
    grain: [
        'facility::key',
    ],
    tableGrain: [
        '!facility',
    ],
    foreignKeys: [
        'facility::key',
    ]
};
const hospitalPricingCode = {
    name: 'hospital-pricing-code',
    tableType: 'fact',
    grain: [
        'facility::key',
    ],
    tableGrain: [
        '!facility',
    ],
    foreignKeys: [
        'facility::key',
    ]
};
const hospitalPricingServiceCF = {
    name: 'hospital-pricing-service-cf',
    tableType: 'fact',
    grain: [
        'facility::key'
    ],
    tableGrain: [
        '!facility'
    ],
    foreignKeys: [
        'facility::key'
    ]
};
const hospitalPricingRelativityCurrent = {
    name: 'hospital-pricing-relativity-current',
    tableType: 'fact',
    grain: [
        'facility::key'
    ],
    tableGrain: [
        '!facility'
    ],
    foreignKeys: [
        'facility::key'
    ]
};
const hospitalPricingRelativityCurrentHCG = {
    name: 'hospital-pricing-relativity-current-hcg',
    tableType: 'fact',
    grain: [
        'facility::key'
    ],
    tableGrain: [
        '!facility'
    ],
    foreignKeys: [
        'facility::key'
    ]
};
const hospitalPricingRelativityMedicareHCGService = {
    name: 'hospital-pricing-relativity-medicare-hcg-service',
    tableType: 'fact',
    grain: [
        'facility::key',
        'cbsa::key',
        'county::key',
        'state::key'
    ],
    tableGrain: [
        '!facility'
    ],
    foreignKeys: [
        'facility::key',
        'cbsa::key',
        'county::key',
        'state::key'
    ]
};
const hospitalCostReportMarginsCalculator = {
    name: 'hospital-cost-report-margins-calculator',
    tableType: 'dim',
    grain: [
        'provider_number',
        'year::key'
    ],
    tableGrain: [
        'provider_number',
        'year::key'
    ],
    foreignKeys: []
};
const hospitalGlobalRVUSConversionFactors = facilityFact('hospital-globalrvus-conversion-factors');
exports.default = [
    hacDomain,
    hsAllPatientsDaysTripsVisits,
    hsBedDays,
    hsBeds,
    hsCah,
    hsCalculatedMetrics,
    hsCapitalAccounts,
    hsCaseMixIndex,
    hsCost,
    healthSystem,
    affiliatedHealthSystem,
    hsDischarges,
    hsEocByDrgGroup,
    hsFullTimeEquivalents,
    hsHacDomain,
    hsIncome,
    hsInpatientRevenue,
    hsMedicareVolume,
    hsOutpatientImagingEfficiency,
    hsOutpatientRevenue,
    hsOverhead,
    hsPaymentReduction,
    hsReadmissionsReduction,
    hsRevenue,
    hsTotalRevenue,
    hsValueBasedPurchasing,
    hsVbpExposure,
    hsWages,
    hsAPMContracts,
    hospCaseMixIndex,
    hospCRAllPatientsDaysTripsVisits,
    hospCRBedDays,
    hospCRBeds,
    hospCRCah,
    hospCRCalculatedMetrics,
    hospCRCapitalAccounts,
    hospCRCost,
    hospCRDischarges,
    hospCREndowmentFundAssets,
    hospCREndowmentFundLiabilities,
    hospCRFullTimeEquivalents,
    hospCRGeneralFundAssets,
    hospCRGeneralFundLiabilities,
    hospCRIncome,
    hospCRInpatientRevenue,
    hospCROutpatientRevenue,
    hospCROverhead,
    hospCRPlantFundAssets,
    hospCRPlantFundLiabilities,
    hospCRRevenue,
    hospCRSpecificPurposeFundAssets,
    hospCRSpecificPurposeFundLiabilities,
    hospCRTitleVDaysTripsVisits,
    hospCRTitleXIXDaysTripsVisits,
    hospCRTitleXVIIIDaysTripsVisits,
    hospCRTotalFundAssets,
    hospCRTotalRevenue,
    hospCRWages,
    hospMdcCaseMixIndex,
    hospMedsurgCaseMixIndex,
    hospOwnershipEocByDrgGroup,
    hospTypeEocByDrgGroup,
    medicareVolume,
    outpatientImagingEfficiency,
    paymentReduction,
    readmissionsComplicationsAndDeaths,
    readmissionsReduction,
    structuralMeasures,
    timelyAndEffectiveCare,
    valueBasedPurchasing,
    hospitalPricing,
    hospitalPricingCode,
    hospitalPricingServiceCF,
    hospitalPricingRelativityCurrent,
    hospitalPricingRelativityCurrentHCG,
    hospitalPricingRelativityMedicareHCGService,
    hospitalCostReportMarginsCalculator,
    hospitalGlobalRVUSConversionFactors
];
